export const statusColours = {
  green: {
    colour: "#9CE098",
    backgroundColour: "#EBF9EA",
  },
  yellow: {
    colour: "#F8EA9F",
    backgroundColour: "#FEFBEC",
  },
  orange: {
    colour: "#FAB03A",
    backgroundColour: "#FCF2E3",
  },
  red: {
    colour: "#E44545",
    backgroundColour: "#FDECEC",
  },
} as const;